import { h, Fragment, Component } from "preact";
import { useMemo } from 'preact/hooks'
import { observer } from "mobx-react";

import {
  Banner,
//  Results as ResultsComponent,
  withStore,
  withController,
} from "@searchspring/snap-preact-components";

import { DesktopFilterSummary } from "../FilterSummary/DesktopFilterSummary";
import { FeaturedFilter } from "../FilterSummary/FeaturedFilter";
import { ProductCount } from '../FilterSummary/ProductCount';
import { Profile } from "../Profile/Profile";
import { ResultsComponent } from './ResultsComponent';
import { SidebarContents, SidebarHeadings } from "../Sidebar/Sidebar";
import { Toolbar } from "../Toolbar/Toolbar";
import { MediaQuery } from '../Helpers/MediaQuery';

import "./results.css";

@withStore
@withController
@observer
export class Results extends Component {
  componentDidMount() {
    const templateWrapper = document.querySelector(".search-results-template-wrapper");

    if (templateWrapper) {
      templateWrapper.classList.add("some-results");
    }
  }

  render() {
    const { merchandising, results, pagination } = this.props.store;
    const controller = this.props.controller;


    let leftColumnLayout = ""

    if(window.Resources.searchspring.toolbar.leftColumnLayout == 'false') {
      leftColumnLayout = ""
    } else {
      leftColumnLayout = window.Resources.searchspring.toolbar.leftColumnLayout;
    }

    return (
      <div class={(leftColumnLayout ? 'ss-results-left-column left-column-wrapper' : 'ss-results')}>
        <Banner content={merchandising.content} type="header" />
        <Banner content={merchandising.content} type="banner" />

        <FeaturedFilter />

        { leftColumnLayout ? null : (
          <MediaQuery query="(min-width: 990px)">
            <div className="ss-results__top-wrapper page-width">
              <ProductCount />
              <Toolbar />
            </div>
          </MediaQuery>
        )
        }

        { !leftColumnLayout ? (
          <MediaQuery query="(max-width: 989px)">
            <ProductCount />
            <Toolbar />
          </MediaQuery>
        ) : (null)
        }

        <div class="clear"></div>

        <Profile name="results" controller={controller}>
          { leftColumnLayout ? (
            <SidebarContents leftColumnLayout={leftColumnLayout} />
          ) : null}
          <div className="ss-results__main-wrapper">
            { leftColumnLayout ? (

              <div className="ss-results__top-wrapper">
                <MediaQuery query="(max-width: 990px)">
                  <SidebarHeadings />
                </MediaQuery>
                
                <MediaQuery query="(min-width: 991px)">
                  <span class="left-hand">
                    <ProductCount />
                    <DesktopFilterSummary />
                  </span>
                </MediaQuery>
                <Toolbar />
              </div>

            ) : null }
            <ResultsComponent
              controller={controller}
              results={results}
            />
          </div>
        </Profile>

        <div class="clear"></div>
      </div>
    );
  }
}

@withController
@withStore
@observer
export class NoResults extends Component {
  componentDidMount() {
    const templateWrapper = document.querySelector('.search-results-template-wrapper')

    if (templateWrapper) {
        templateWrapper.classList.add('no-results')
    }
}

  render() {
    const store = this.props.store;
    return null;
  }
}
